import React, { Component } from 'react'
import { withRouter } from 'react-router'
import SidebarItem from './sidebar-item'
import FolderSystem from 'components/folder/folder-system'

import { connect } from 'react-redux'
import { openModal } from 'state/actions'

import Icon from 'components/icon/icon'

import { clone } from 'lodash'

class Sidebar extends Component {
	state = {
		folderSystemHeight: 150,
		minFolderSystemHeight: 150,
		isFolderSystemHovered: false,
	}

	sidebarRef = null

	shouldComponentUpdate = nextProps => {
		const {
			isHidden,
			location
		} = this.props

		if (isHidden !== nextProps.isHidden) {
			return true
		}

		if (this.props.activeHeaderTab !== nextProps.activeHeaderTab) {
			return false
		}

		if (this.props.chatBehaviourTrigger !== nextProps.chatBehaviourTrigger) {
			return false
		}

		return true
	}

	componentWillMount = _ => {
		window.addEventListener('resize', this.handleResize)
	}

	componentWillUnmount = _ => {
		window.removeEventListener('resize', this.handleResize)
	}

	updateFolderSystemHeight = (newHeight, force = false) => {
		setTimeout(_ => {
			if (this.minHeightContainerRef) {
				let minHeight = this.minHeightContainerRef.clientHeight

				let finalHeight = clone(newHeight)

				let newState = {
					...this.state
				}

				if (this.state.isFolderSystemHovered) {
					finalHeight = minHeight + 30
				} else if (force) {
					finalHeight = minHeight
				}

				newState.folderSystemHeight = finalHeight

				this.setState(newState)
			}
		}, 100)
	}

	toggleButtons = isVisible => {
		const {
			userRoles,
		} = this.props

		if (userRoles.guest) {
			return
		}

		this.setState({
			isFolderSystemHovered: isVisible
		})

		let newHeight = this.state.folderSystemHeight

		this.updateFolderSystemHeight(newHeight, true)
	}

	openFeedbackModal = _ => {
		this.props.openModal('feedback', 'feedback')
	}

	render() {
		const {
			toggleSidebar,
			url,
			location,
			isHidden,
			accountData,
			userRoles
		} = this.props

		// not destructured, otherwise you'll get a duplicate declaration
		const folderSystemHeight = isHidden ? 0 : this.state.folderSystemHeight

		return (
			<aside
				id="sidebar"
				className={`sidebar ${isHidden ? 'hidden' : ''}`}
				ref={ref => this.sidebarRef = ref}
			>
				<ul>
					<SidebarItem
						title="Dashboard"
						link={url + "/dashboard"}
						icon="fe-layout"
						location={location}
					/>
					<SidebarItem
						title="Projects"
						link={url + "/projects"}
						icon="star"
						location={location}
					/>
					<div
						className="folder-system-container"
						style={{ height: folderSystemHeight + 'px' }}
						onMouseEnter={_ => {
							this.toggleButtons(true)
						}}
						onMouseLeave={_ => {
							this.toggleButtons(false)
						}}
					>
						<div
							ref={ref => this.minHeightContainerRef = ref}
							id={'sidebar-folder-container'}
							className="folder-min-height-container"
						>
							<FolderSystem
								path={location.pathname}
								updateHeightCallback={this.updateFolderSystemHeight}
								compact
								stateCallback={this.updateState}
							/>
						</div>
					</div>
					<SidebarItem
						title={"People"}
						link={url + "/people"}
						icon="user-circle-o"
						location={location}
					/>
					{accountData.has_meetings ?
						<SidebarItem
							title={"Reporting"}
							link={url + "/reporting"}
							icon="drivers-license-o"
							location={location}
						/>
						: null}
					{(userRoles && (userRoles.admin || userRoles.pm)) ?
						<SidebarItem
							title={'Planning'}
							link={url + '/planning'}
							icon={'fe-clipboard'}
							location={location}
						/>
						: null}

					<SidebarItem
						title={"Chat"}
						link={url + "/chat"}
						icon="fe-mail"
						location={location}
						isNewTab
					/>
				</ul>
				<button
					onClick={toggleSidebar}
					className='hide-sidebar'
				>
					<Icon name='angle-left' />
					<span>
						Hide sidebar
					</span>
					<Icon name='angle-right' />
				</button>
			</aside>
		)
	}

}

export default withRouter(connect(null, {
	openModal
})(Sidebar))


// WEBPACK FOOTER //
// ./src/layout/sidebar/sidebar.jsx